/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../layout.ts"/>

namespace Dealerware {
    export namespace Layout {

        "use strict";

        export interface IDealerwarePrivateLayoutDelegate extends IDealerwareLayoutDelegate {

        }


        export interface IDealerwarePrivateLayoutController extends IDealerwareLayoutController {

        }

        export class DealerwarePrivateLayoutDelegate extends DealerwareLayoutDelegate implements IDealerwarePrivateLayoutDelegate {

            // properties
            // --------------------------------------------

            public static $inject: string[] = ['$state','$mobilityCurrentStateDelegate'];

            // constructor
            // --------------------------------------------
            constructor(public $state : any, public $mobilityCurrentStateDelegate : any) {
                super($state,$mobilityCurrentStateDelegate);
                this.configSectionKey   =   'privateLayout';
            }

            // methods
            // --------------------------------------------


        }

        export class DealerwarePrivateLayoutController extends DealerwareLayoutController implements IDealerwarePrivateLayoutController {

            // properties
            // ----------------------------------------------
            public static $inject   :   string[] = ['$dealerwarePrivateLayoutDelegate','$rootScope','$scope','$timeout'];

            // constructor
            // ----------------------------------------------
            constructor(public layoutService : IDealerwarePrivateLayoutDelegate,public $rootScope : any, public $scope : any, public $timeout : any) {
                super(layoutService,$rootScope,$scope,$timeout);
            }

            // methods
            // ----------------------------------------------

            public registerEvents() : void {

                var _self = this;

                super.registerEvents();

                // stateChangeSuccess
                this.registeredEvents.push(
                    this.$rootScope.$on('$stateChangeSuccess',function() {
                        _self.handleStateChangeSuccess();
                    })
                );

            }

            public handleStateChangeSuccess() : void {
                this.layoutService.getLayoutClass();
            }

        }

        getDealerwareLayoutModule().service('$dealerwarePrivateLayoutDelegate',DealerwarePrivateLayoutDelegate);
        getDealerwareLayoutModule().controller('$dealerwarePrivateLayoutController',DealerwarePrivateLayoutController);

    }
}